import styled, { css } from 'styled-components';

import Method from '../../Method';

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
`;

const PaymentMethod = styled(Method)`
    &:not(:last-child) {
        margin-bottom: 8px;
    }
    ${({ isActive }) => !isActive && css`
        cursor: pointer;
    `}
`;

export { Wrap, PaymentMethod };
